/*
—————————————————————————————————————————————————————————————————————————
  https://www.martar.fr/articles/un-bus-de-communication-pour-vuejs     —
                                                                        —
  on créer une instance de Vue indépendante uniquement dédiée           —
  à la réception et à l'émission d'événements.                          —
—————————————————————————————————————————————————————————————————————————
*/
import Vue from 'vue'
export default new Vue()



// WEBPACK FOOTER //
// ./src/utils/bus.js